import React from 'react';
import { Box, Typography, Paper, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { VideoLibrary, CheckCircleOutline } from '@mui/icons-material';
import DynamicMerchantTabs from '../Layout/DynamicMerchantTabs';

const PURPLE = '#6318C6';
const PURPLE_LIGHT = '#f3eeff';

const capabilities = [
  'Generate authentic-looking UGC-style product videos using AI',
  'Simulate real customer unboxing and try-on scenarios',
  'Produce content optimised for Instagram Stories, Reels, and TikTok',
  'Reduce content creation cost vs hiring real UGC creators',
];

export default function UGCVideosPage() {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', bgcolor: '#f8f9fa' }}>
      <DynamicMerchantTabs />
      <Box sx={{ flex: 1, p: { xs: 2, md: 4 }, maxWidth: 720, mx: 'auto', width: '100%' }}>
        <Paper sx={{ p: 4, borderRadius: 3, border: '1px solid #e5e7eb' }}>
          <Box display="flex" alignItems="center" gap={2} mb={3}>
            <Box sx={{ width: 56, height: 56, borderRadius: 2, bgcolor: PURPLE_LIGHT, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <VideoLibrary sx={{ color: PURPLE, fontSize: 28 }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={700}>UGC Videos</Typography>
              <Typography variant="body2" color="text.secondary">AI-generated user content style videos</Typography>
            </Box>
          </Box>

          <Typography color="text.secondary" mb={3}>
            Create AI-powered user-generated content style videos that look and feel authentic —
            without needing real creators, studios, or expensive production budgets.
          </Typography>

          <Typography variant="subtitle2" fontWeight={700} mb={1.5}>What you can do</Typography>
          <List disablePadding>
            {capabilities.map((cap) => (
              <ListItem key={cap} disableGutters sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  <CheckCircleOutline sx={{ color: PURPLE, fontSize: 18 }} />
                </ListItemIcon>
                <ListItemText primary={<Typography variant="body2">{cap}</Typography>} />
              </ListItem>
            ))}
          </List>
        </Paper>
      </Box>
    </Box>
  );
}
